import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AlarmControl } from '../../models/alarm-control';
import { map } from 'rxjs/operators';
import { AlarmControlBuilder } from '../../models/builders/alarm-control.builder';
import { AlarmActionBuilder } from '../../models/builders/alarm-action.builder';

const activityControlBody = (alarmControl: AlarmControl) => ({
  description: alarmControl.description,
  alarmTxt: alarmControl.alarmTxt,
  action: alarmControl.action,
  controlHash: alarmControl.control
});

@Injectable()
export class AlarmControlApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }alarm-controls`;
  }

  createAlarmControl(alarmControl) {
    return this.httpClient.post(this.apiUrl, activityControlBody(alarmControl)).pipe(map(AlarmControlBuilder.fromJson));
  }

  deleteAlarmControl(alarmControl: AlarmControl) {
    return this.httpClient.delete(`${ this.apiUrl }/${ alarmControl.hash }`);
  }

  getAlarmActions() {
    return this.httpClient.get(`${ this.apiUrl }/actions`).pipe(map(AlarmActionBuilder.fromList));
  }

  getAlarmControls() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(AlarmControlBuilder.fromList));
  }

  getAlarmControl(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(AlarmControlBuilder.fromJson)
      );
  }

  updateAlarmControl(alarmControl: AlarmControl) {
    return this.httpClient.put(`${ this.apiUrl }/${ alarmControl.hash }`, activityControlBody(alarmControl));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/alarm-control-api.service.ts